<template>
  <div class="appMobile">
    <div>
      <div class="contain one">
        <div class="top">
          <div class="top-img">
            <img
              style="width: 60%;margin-left: 20%;margin-right: 20%;"
              alt="xxx"
              src="../../assets/picshow/imgs/102.png"
            />
          </div>
        </div>
        <div class="middle">
          <div
            class="text"
          >上汽大众35年不断启程，不断突破，在时代潮流中一步步走向成熟。奋斗在各个岗位的上汽大众人与企业同舟共济，一同成长，留下了无数值得铭记的瞬间。以“我们都是上汽大众人”为主题的图片展讲述了关于上汽大众人的故事，记录了那些关于坚守、拼搏与创新的点滴。</div>
          <div
            class="text-en"
          >Over the past 35 years, SAIC VOLKSWAGEN keeps making breakthroughs and develops by following the trends.Every staff here works together and shares efforts. During this process, numerous magic moments and events are recorded by photos.The photo exhibition "We Are All The People Of SAIC VOLKSWAGEN" presents our stories, and records the details of struggle.</div>
        </div>
      </div>
      <div class="contain two">
        <div>
          <div class="item">
            <div class="item-top">
              <img style="width:100%" src="../../assets/picshow/imgsMobile/201.png" />
            </div>
            <div class="item-foot">
              <div class="item-foot-des">
                <swiper :imgs="imgs_1"></swiper>
              </div>
              <div class="item-foot-page">
                <img
                  style="margin-right: 6.2666666666667%;width:1.6%;"
                  src="../../assets/picshow/imgsMobile/101.png"
                />
                <div class="showmore">
                  滑动查看更多图片
                  <br />To see more photos by swiping
                </div>
                <img
                  style="margin-left: 6.2666666666667%;width:1.6%;"
                  src="../../assets/picshow/imgsMobile/102.png"
                />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-top">
              <img style="width:100%" src="../../assets/picshow/imgsMobile/202.png" />
            </div>
            <div class="item-foot">
              <div class="item-foot-des">
                <swiper :imgs="imgs_2"></swiper>
              </div>
              <div class="item-foot-page">
                <img
                  style="margin-right: 6.2666666666667%;width:1.6%;"
                  src="../../assets/picshow/imgsMobile/101.png"
                />
                <div class="showmore">
                  滑动查看更多图片
                  <br />To see more photos by swiping
                </div>
                <img
                  style="margin-left: 6.2666666666667%;width:1.6%;"
                  src="../../assets/picshow/imgsMobile/102.png"
                />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item-top">
              <img style="width:100%" src="../../assets/picshow/imgsMobile/203.png" />
            </div>
            <div class="item-foot">
              <div class="item-foot-des">
                <swiper :imgs="imgs_3"></swiper>
              </div>
              <div class="item-foot-page">
                <img
                  style="margin-right: 6.2666666666667%;width:1.6%;"
                  src="../../assets/picshow/imgsMobile/101.png"
                />
                <div class="showmore">
                  滑动查看更多图片
                  <br />To see more photos by swiping
                </div>
                <img
                  style="margin-left: 6.2666666666667%;width:1.6%;"
                  src="../../assets/picshow/imgsMobile/102.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swiper from "@/components/swiper/picshow/Swiper.vue";
export default {
  data() {
    return {
      isPhone: false,
      imgs_1: [
        {
          src: require("../../static/picshow/imgs/211.jpg"),
          text: "1983年，第一辆桑塔纳组装成功。",
          textEn: "In 1983, The first Santana was successfully assembled."
        },
        {
          src: require("../../static/picshow/imgs/212.jpg"),
          text: "2012年，参与缔造第一辆桑塔纳的员工与全新一代桑塔纳合影。",
          textEn:
            "In 2012, employees participated in assembling of the first Santana took a group photo with a new generation of Santana."
        },
        {
          src: require("../../static/picshow/imgs/213.jpg"),
          text: "每一个零件的精准匹配，只为每一辆车的完美。",
          textEn:
            "Accurate matching of every part, just for the perfection of every car."
        },
        {
          src: require("../../static/picshow/imgs/214.jpg"),
          text: "30多年如一日，质保人用坚守诠释着“质量”的承诺。",
          textEn:
            "For decades,people of quality assurance adhere to their commitment of 'quality'."
        },
        {
          src: require("../../static/picshow/imgs/215.jpg"),
          text:
            "35年来，我们一直倾听中国用户需求，坚持做最懂中国消费者的设计。",
          textEn:
            "Over the past 35 years, we have been listening to the needs of Chinese users and insisting on the design that understands Chinese consumers best."
        },
        {
          src: require("../../static/picshow/imgs/216.jpg"),
          text: "坚持用心聆听来自质量的每一个声音。",
          textEn: "Keep listening to every voice from quality."
        },
        {
          src: require("../../static/picshow/imgs/217.jpg"),
          text: "坚持绿色生产，守护我们的家园。",
          textEn: "Green production for our environment."
        },
        {
          src: require("../../static/picshow/imgs/218.jpg"),
          text: "一丝不苟，用心打磨品质。",
          textEn: "Meticulously craftsmanship."
        },
        {
          src: require("../../static/picshow/imgs/219.jpg"),
          text: "细微之间，坚持一颗工匠之心。",
          textEn: "Craftsmanship in every detail."
        },
        {
          src: require("../../static/picshow/imgs/220.jpg"),
          text:
            "真诚的笑容、贴心的关爱，坚持以热情和专业的服务赢得千万客户的口碑。",
          textEn:
            "Sincere smile, caring, enthusiasm and professional service to win good customer reputation."
        },
        {
          src: require("../../static/picshow/imgs/221.jpg"),
          text: "下班路上，意犹未尽，伴着落日余晖继续闪耀创想的光芒！",
          textEn:
            "On our way home, creative thoughts continue to sparkle in the sunset!"
        }
      ],
      imgs_2: [
        {
          src: require("../../static/picshow/imgs/311.jpg"),
          text: "繁忙而有序的生产线，是每一位一线员工拼搏的战场。",
          textEn:
            "The busy and orderly production line is the battleground for every front-line employee."
        },
        {
          src: require("../../static/picshow/imgs/312.jpg"),
          text: "无论身处哪个工位，我们都拥有同样的拼搏情怀。",
          textEn: "No matter where we are, we have the same spirit of striving."
        },
        {
          src: require("../../static/picshow/imgs/313.jpg"),
          text: "不一样的岗位，一样的拼搏努力。",
          textEn: `Joints efforts in different posts.`
        },
        {
          src: require("../../static/picshow/imgs/314.jpg"),
          text: "平凡的岗位，因为你的拼搏而绽放光芒。",
          textEn: "Ordinary positions shine because of your hard work."
        },
        {
          src: require("../../static/picshow/imgs/315.jpg"),
          text: "恪守职责使命 书写拼搏华章。",
          textEn: "Adhere to responsibilities and struggle for achievements."
        },
        {
          src: require("../../static/picshow/imgs/316.jpg"),
          text:
            "西进新疆，北上黑河，不怕苦的试车员们拼搏在“全天候”“全路况”的测试道路上。",
          textEn: `Going west into Xinjiang, heading north to the Black River, test drivers faced all difficulties and struggled on the "all-weather" and "all-condition" test roads.`
        },
        {
          src: require("../../static/picshow/imgs/3162.jpg"),
          text:
            "西进新疆，北上黑河，不怕苦的试车员们拼搏在“全天候”“全路况”的测试道路上。",
          textEn: `Going west into Xinjiang, heading north to the Black River, test drivers faced all difficulties and struggled on the "all-weather" and "all-condition" test roads.`
        },
        {
          src: require("../../static/picshow/imgs/3163.jpg"),
          text:
            "西进新疆，北上黑河，不怕苦的试车员们拼搏在“全天候”“全路况”的测试道路上。",
          textEn: `Going west into Xinjiang, heading north to the Black River, test drivers faced all difficulties and struggled on the "all-weather" and "all-condition" test roads.`
        },
        {
          src: require("../../static/picshow/imgs/3164.jpg"),
          text:
            "西进新疆，北上黑河，不怕苦的试车员们拼搏在“全天候”“全路况”的测试道路上。",
          textEn: `Going west into Xinjiang, heading north to the Black River, test drivers faced all difficulties and struggled on the "all-weather" and "all-condition" test roads.`
        },
        {
          src: require("../../static/picshow/imgs/317.jpg"),
          text:
            "他们站在疫情防控的最前沿，和时间赛跑，和自己赛跑，为每一位员工的安全保驾护航。",
          textEn:
            "They standed at the forefront of epidemic prevention and control, raced against time and themselves, ensuring safety of every employee."
        },
        {
          src: require("../../static/picshow/imgs/318.jpg"),
          text: "奋战在疫情防控的最前沿的他们，为每一位员工的安全保驾护航。",
          textEn:
            "They standed at the forefront of epidemic prevention and control, ensuring safety of every employee."
        },
        {
          src: require("../../static/picshow/imgs/3182.jpg"),
          text: "奋战在疫情防控的最前沿的他们，为每一位员工的安全保驾护航。",
          textEn:
            "They standed at the forefront of epidemic prevention and control, ensuring safety of every employee."
        },
        {
          src: require("../../static/picshow/imgs/3183.jpg"),
          text: "奋战在疫情防控的最前沿的他们，为每一位员工的安全保驾护航。",
          textEn:
            "They standed at the forefront of epidemic prevention and control, ensuring safety of every employee."
        }
      ],
      imgs_3: [
        {
          src: require("../../static/picshow/imgs/411.jpg"),
          text:
            "IT人为企业数字化转型打通全方位、全过程、全领域的数据实时交互。",
          textEn:
            "IT workers provide all-round, whole process and all field real-time data interaction for digital transformation."
        },
        {
          src: require("../../static/picshow/imgs/4112.jpg"),
          text:
            "IT人为企业数字化转型打通全方位、全过程、全领域的数据实时交互。",
          textEn:
            "IT workers provide all-round, whole process and all field real-time data interaction for digital transformation."
        },
        {
          src: require("../../static/picshow/imgs/4113.jpg"),
          text:
            "IT人为企业数字化转型打通全方位、全过程、全领域的数据实时交互。",
          textEn:
            "IT workers provide all-round, whole process and all field real-time data interaction for digital transformation."
        },
        {
          src: require("../../static/picshow/imgs/412.jpg"),
          text: "智能化，是物流管理的变革，更是精益化管理理念的创新应用。",
          textEn:
            "Intelligent network is the transform of logistics management and also the innovative application of lean management concept."
        },
        {
          src: require("../../static/picshow/imgs/4122.jpg"),
          text: "智能化，是物流管理的变革，更是精益化管理理念的创新应用。",
          textEn:
            "Intelligent network is the transform of logistics management and also the innovative application of lean management concept."
        },
        {
          src: require("../../static/picshow/imgs/4123.jpg"),
          text: "智能化，是物流管理的变革，更是精益化管理理念的创新应用。",
          textEn:
            "Intelligent network is the transform of logistics management and also the innovative application of lean management concept."
        },
        {
          src: require("../../static/picshow/imgs/413.jpg"),
          text: "造型研发",
          textEn: "Design R & D"
        },
        {
          src: require("../../static/picshow/imgs/4132.jpg"),
          text: "造型研发",
          textEn: "Design R & D"
        },
        {
          src: require("../../static/picshow/imgs/414.jpg"),
          text: "虚拟现实研发",
          textEn: "Virtual Reality R & D"
        },
        {
          src: require("../../static/picshow/imgs/4142.jpg"),
          text: "虚拟现实研发",
          textEn: "Virtual Reality R & D"
        },
        {
          src: require("../../static/picshow/imgs/4143.jpg"),
          text: "虚拟现实研发",
          textEn: "Virtual Reality R & D"
        },
        {
          src: require("../../static/picshow/imgs/4152.jpg"),
          text: "智能驾驶研发",
          textEn: "Autonomous Driving R & D"
        },
        {
          src: require("../../static/picshow/imgs/417.jpg"),
          text: "电磁兼容试验",
          textEn: "Electromagnetic Compatibility Test"
        },
        {
          src: require("../../static/picshow/imgs/4182.jpg"),
          text: "新能源车研发",
          textEn: "New Energy Vehicle Engineering R&D"
        },
        {
          src: require("../../static/picshow/imgs/419.jpg"),
          text: "移动互联团队",
          textEn: "Connectivity Team"
        },
        {
          src: require("../../static/picshow/imgs/4192.jpg"),
          text: "移动互联团队",
          textEn: "Connectivity Team"
        }
      ]
    };
  },
  components: {
    swiper
  },
  methods: {}
};
</script>
<style scoped>
.showmore {
  font-size: 9px;
  color: rgba(22, 133, 218, 1);
  line-height: 14px;
}
.item-foot-des {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-left: 4%;
  margin-right: 4%;
  width: 92%;
  margin-bottom: 27.5px;
  background: rgba(242, 242, 242, 1);
}
.item-foot-page {
  margin-bottom: 64.5px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.cnfont {
  text-align: left;
  margin-top: 18px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 10px;
  font-size: 10px;
  color: rgba(32, 32, 32, 1);
  line-height: 20px;
}
.enfont {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 20px;
  font-size: 9px;
  color: rgba(32, 32, 32, 1);
  line-height: 16px;
}

.item-top {
  width: 100%;
  height: auto;
  position: relative;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.top {
  position: relative;
  width: 100%;
  padding-top: 100%;
  background-image: url("../../assets/picshow/imgsMobile/103.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.top-img {
  width: 100%;
  position: absolute;
  margin-top: -5.3%;
}

.middle {
  margin: 22.5% 18px 60.5px 17px;
}

.text {
  font-size: 12px;
  color: rgba(32, 32, 32, 1);
  line-height: 20px;
}

.text-en {
  margin-top: 10px;
  font-size: 9px;
  color: rgba(32, 32, 32, 1);
  line-height: 18px;
}
</style>
